var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"layout-container flex-center layout-backtop"},[_c('Headers'),_c('Mains'),_c('el-backtop',{attrs:{"target":".layout-backtop .el-main .el-scrollbar__wrap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }